<template>
  <div
    v-if="!gettingMetricsStatus"
    id="homeContent"
    class="pushFooter"
  >
    <div v-if="customHome">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-html="customHtml.html" />
    </div>
    <div
      v-else
      class="band"
    >
      <div class="bandContent mainPage dontPadExtra">
        <div class="splitColumns">
          <div class="column33 packageLabels">
            <div
              v-for="p in packages"
              :key="p"
              class="packageLabel"
              :class="p"
            >
              {{ p }}
            </div>
          </div>
          <div
            class="column67"
            style="text-align:center"
          >
            <p class="welcome">
              Welcome to RStudio Package Manager
            </p>
            <p class="tagline">
              Control and distribute packages throughout your organization
            </p>
            <div class="actions">
              <router-link
                class="bigButton"
                data-automation="home-start-button"
                :to="{ name: 'packages', params: { repoId: repoId } }"
              >
                Get Started
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import * as types from '../store/mutation-types'
import sanitizeHtml from 'sanitize-html'
import { uriToAbs } from '../utils/path-utils'
import { helpers, getDevApiBase } from '../api/http-common'

export default {
  name: 'Home',
  data: function () {
    return {
      packages: ['shiny', 'dplyr', 'tibble', 'readr', 'rmarkdown', 'formatR', 'tidyr', 'BH', 'R6', 'devtools', 'readxl', 'ggplot2', 'microbenchmark'],
    }
  },
  computed: {
    ...mapState({
      gettingMetricsStatus: state => state.status.gettingMetricsStatus,
      repoId: state => state.repos.currentRepoId ? state.repos.currentRepoId : -1,
      customHomeHtml: state => state.status.custom_home_html,
      customHome: state => state.status.custom_home,
      scrollTop: state => state.appFrame.scrollTop,
    }),
    customHtml: function () {
      if (this.customHomeHtml) {
        // Compute the base URL against which all relative references should be resolved.
        const { isApiProd } = helpers.environments(process.env.API_ENV, process.env.NODE_ENV)
        const assetsPath = isApiProd ? `${helpers.basePath(window)}__api__/custom/home/` : `${getDevApiBase()}/home/`
        return {
          html: sanitizeHtml(this.customHomeHtml, {
          // Allow all tags
            allowedTags: false,
            // Allow all attributes
            allowedAttributes: false,
            // Transform image and CSS URLs
            transformTags: {
              // Convert relative to absolute URLs.
              // Inspired by https://github.com/microcosm-cc/bluemonday/blob/f0761eb8ed07c1cc892ef631b00c33463b9b6868/sanitize.go#L321-L349
              // We hoped that the baseUrl parameter would work, but it seems to miss links and
              // images that are inserted in HTML directly (not using markdown syntax). When I used
              // a baseUrl parameter in addition to transformTags, then markdown-based references were
              // rebased twice. Example:
              // https://github.com/tidyverse/dplyr/blame/3e3ade18a3b20bac354b8ba2ae9d29287c260b6a/README.md#L4
              img: uriToAbs('src', assetsPath),
              link: uriToAbs('href', assetsPath),
            },
          }),
        }
      } else if (this.customHome) {
        this.$store.dispatch('getCustomPage', { page: 'home' })
      }
      // Return an empty, valid object to avoid UI errors.
      return { html: '', raw: '' }
    },
  },
  watch: {
    scrollTop: function (st) {
      this.$store.commit(types.SET_SHRINK_HEADER, st > 500)
    },
  },
  created: function () {
    this.$store.commit(types.SET_SHRINK_HEADER, false)
    this.$store.commit(types.SET_SHOW_FOOTER, true)
    this.$store.commit(types.SET_NAV_TOGGLER_AS_NEEDED, true)
    this.$store.commit(types.SET_HEADER_TITLE, '')
  },
}
</script>
